<template>
  <transition name="install">
    <div v-if="show" class="install">
      <div class="install__icon">
        <svg viewBox="0 0 24 24" class="icon">
          <path d="M12 3v12" />
          <polyline points="7 11 12 16 17 11" />
          <line x1="5" y1="20" x2="19" y2="20" />
        </svg>
      </div>

      <div class="install__text">
        <strong>Zainstaluj aplikację</strong>
        <span v-if="!isIOS">Dodaj Naprawa Online do ekranu głównego telefonu.</span>
        <span v-else>
          Stuknij
          <svg viewBox="0 0 24 24" class="install__ios-icon">
            <path d="M12 16V4" />
            <polyline points="8 8 12 4 16 8" />
            <path d="M5 12v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7" />
          </svg>
          a następnie „Do ekranu początkowego".
        </span>
      </div>

      <button v-if="!isIOS" class="install__btn" @click="install">
        Zainstaluj
      </button>
      <button class="install__close" @click="dismiss" aria-label="Zamknij">
        <svg viewBox="0 0 24 24" class="icon">
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
  </transition>
</template>

<script>
const DISMISS_KEY = "pwa_install_dismissed";

export default {
  name: "InstallPrompt",
  data() {
    return {
      show: false,
      isIOS: false,
      deferredPrompt: null,
    };
  },
  mounted() {
    // Juz zainstalowana (uruchomiona jako standalone) -> nie pokazuj
    const standalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;
    if (standalone) return;

    // Uzytkownik wczesniej zamknal baner -> nie nagabuj
    if (localStorage.getItem(DISMISS_KEY) === "1") return;

    const ua = window.navigator.userAgent.toLowerCase();
    this.isIOS = /iphone|ipad|ipod/.test(ua) && !window.MSStream;

    if (this.isIOS) {
      // iOS Safari nie wspiera beforeinstallprompt — pokazujemy instrukcje
      this.show = true;
    } else {
      // Android / Chrome / Edge — przechwyc natywny prompt i pokaz wlasny przycisk
      window.addEventListener("beforeinstallprompt", this.onBeforeInstall);
      window.addEventListener("appinstalled", this.onInstalled);
    }
  },
  beforeDestroy() {
    window.removeEventListener("beforeinstallprompt", this.onBeforeInstall);
    window.removeEventListener("appinstalled", this.onInstalled);
  },
  methods: {
    onBeforeInstall(e) {
      e.preventDefault();
      this.deferredPrompt = e;
      this.show = true;
    },
    onInstalled() {
      this.show = false;
      this.deferredPrompt = null;
    },
    install() {
      if (!this.deferredPrompt) return;
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.finally(() => {
        this.show = false;
        this.deferredPrompt = null;
      });
    },
    dismiss() {
      this.show = false;
      localStorage.setItem(DISMISS_KEY, "1");
    },
  },
};
</script>
